<template>
  <v-list-item v-if="!isEditing" ripple class="it-hv">
    <abt-item-avatar :icon="'fal fa-robot'" :note="''" />
    <v-list-item-content>
      <v-list-item-subtitle v-if="!isNoteEmpty" class="caption">趣味・特技</v-list-item-subtitle>
      <v-list-item-title :class="isNoteEmpty ? '' : 'caption'">{{ printNote }}</v-list-item-title>
    </v-list-item-content>
    <v-list-item-action>
      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-btn icon v-on="on" color="secondary" :loading="isThisLoading" @click="edit">
            <v-icon small>fal fa-pencil</v-icon>
          </v-btn>
        </template>
        <span>編集する</span>
      </v-tooltip>
    </v-list-item-action>
  </v-list-item>
  <v-container v-else>
    <v-row dense class="pb-4">
      <v-col cols="12" class="px-3">
        <v-text-field
          v-model="form.note"
          label="趣味・特技は何ですか？"
          counter="50"
          :rules="rules.note"
        />
      </v-col>
    </v-row>
    <v-divider></v-divider>
  </v-container>
</template>

<script>
import AbtItemAvatar from '../../../../../components/avatar'
export default {
  name: 'clientAboutBackgroundsHomestayHobby',
  components: {
    AbtItemAvatar
  },
  props: [
    'status',
    'data'
  ],
  data () {
    return {
      config: {
        type: 'hobby',
        datepicker: {
          publish: false,
          expire: false
        }
      },
      meta: {
      },
      form: {
        id: '',
        note: ''
      },
      rules: {
        note: [
          v => !!v || '必須項目です'
        ]
      }
    }
  },
  methods: {
    prepare: function (dt) {
      if (dt) {
        this.$set(this, 'form', {
          id: '' + (dt.id ? dt.id : ''),
          note: dt.note ? dt.note : ''
        })
      } else if (this.$props.data) {
        this.$set(this, 'form', {
          id: '' + (this.$props.data.id ? this.$props.data.id : ''),
          note: this.$props.data.note ? this.$props.data.note : ''
        })
      }
    },
    edit: function () {
      this.prepare()
      this.$emit('emit', {
        action: 'edit',
        data: {
          type: this.config.type
        }
      })
    },
    changed: function () {
      this.prepare({
        id: '' + (this.$props.data.id ? this.$props.data.id : ''),
        note: this.form.note ? this.form.note : ''
      })
    },
    getForm: function () {
      return this.form
    }
  },
  computed: {
    isLoading () {
      return this.config.status.loading
    },
    isEditing () {
      return !!(
        this.$props.status &&
        this.$props.status.editing &&
        this.$props.data &&
        this.$props.data.id &&
        (this.$props.status.editing === 'all' || this.$props.status.editing === this.config.type)
      )
    },
    isThisEditing () {
      return !!(
        this.$props.status &&
        this.$props.status.editing &&
        this.$props.data &&
        this.$props.data.id &&
        this.$props.status.editing === this.config.type
      )
    },
    isThisLoading () {
      return !!(
        this.$props.status &&
        this.$props.status.loading &&
        this.$props.data &&
        this.$props.data.id &&
        this.$props.status.loading === this.config.type
      )
    },
    printNote () {
      return (
        this.$props.data &&
        this.$props.data.note
      ) ? this.$props.data.note : '趣味・特技の回答'
    },
    isNoteEmpty () {
      return !(
        this.$props.data &&
        this.$props.data.note
      )
    }
  }
}
</script>
